export default __webpack_public_path__ + "static/melt-2f4e2b61ee33e20c087fbe09def4b0f4.png";